import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

import {
  getPoliticsAndProcedures,
  deletePoliticsAndProcedures,
} from "../../../redux/descriptorsProfiles/PoliticsAndProcedures/actions";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import config from "../../../config";
import { get_tasks } from "../../../redux/tasks/actions";

const PoliticsAndProcedures = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");

  const dispatch = useDispatch();

  const {
    loading,
    politicsAndProceduresLength,
    politicsAndProcedures,
    politicsAndProcedureError,
  } = useSelector((store) => store.politicsAndProcedure);
  const pages = Math.ceil(politicsAndProceduresLength / limit);
  const { generalInfos } = useSelector((store) => store.generalInfo);

  const { email } = config.gestorDocumental;

  const tasks = useSelector((store) => store.tasks.tasks);

  // let funcionOptions = [];
  // tasks &&
  //   tasks.map((task) => {
  //     funcionOptions = [
  //       ...funcionOptions,
  //       {
  //         id: task.id,
  //         label: task.descripcion
  //           ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
  //           : "",
  //       },
  //     ];
  //   });
  // let descriptorOptions = [];
  // generalInfos &&
  //   generalInfos.map((gen) => {
  //     descriptorOptions = [
  //       ...descriptorOptions,
  //       {
  //         id: gen.id,
  //         label: gen.nombre_posicion.toUpperCase(),
  //       },
  //     ];
  //   });

  const columns = [
    {
      Header: "Política y procedimiento",
      accessor: "nombre",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {value.row.original.url && value.row.original.url !== "" && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Url gestor documental</Tooltip>}
            >
              <Button
                size="sm"
                variant="link"
                type="button"
                className="text-info rounded"
                onClick={() => {
                  const win = window.open(value.row.original.url);
                  win.focus();
                }}
              >
                <i className="material-icons">link</i>
              </Button>
            </OverlayTrigger>
          )}
          {/* {value.row.original.archivo && (
            <> */}
          {/* <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Descargar archivo</Tooltip>}
              >
                <div>
                  <LinkDescargaListGD
                    id={value.row.original.id}
                    filters={{
                      email: email,
                      id: value.row.original.list_archivo[0].id_documento,
                      llave: value.row.original.list_archivo[0].llave,
                    }}
                    origen={value.row.original.list_archivo[0].origen}
                    icono={<i className="material-icons">file</i>}
                    cType={value.row.original.list_archivo[0].contentTypeGD}
                  />
                </div>
              </OverlayTrigger> */}
          {/* <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Eliminar</Tooltip>}
              >
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onDelete(value.row.original.id, value.row.index)
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
              </OverlayTrigger> */}
          {/* </>
          )} */}
        </div>
      ),
    },
  ];

  // Métodos
  const _getPoliticsAndProcedures = (
    offs = offset,
    lim = limit,
    filt = filter
  ) =>
    dispatch(
      getPoliticsAndProcedures({
        offset: offs,
        limit: lim,
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );

  useEffect(() => {
    _getPoliticsAndProcedures();
    dispatch(get_tasks({}));
  }, [props.match.params.id]);

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePoliticsAndProcedures(id, index));
      window.alert("Se borro este archivo");
    }
  };

  return (
    <>
      <Container >
        <Col className="mt-4">
          <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                POLÍTICAS Y PROCEDIMIENTOS
              </h6>
            </Row>
          </Col>
          {!loading &&
            politicsAndProceduresLength === 0 &&
            politicsAndProcedureError === "" && (
              <Col className="mx-0 px-0">
                <hr />
              </Col>
            )}
        </Col>
        {loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : (
          politicsAndProceduresLength > 0 && (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 mx-2 px-sm-2">
                  <CustomTable columns={columns} data={politicsAndProcedures} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={politicsAndProceduresLength}
                pages={pages}
                pagFunc={_getPoliticsAndProcedures}
              />
            </>
          )
        )}
        {!loading &&
          politicsAndProceduresLength === 0 &&
          politicsAndProcedureError === "" && (
            <Alert variant="info" className="my-4 mx-3">
              Aún no hay registros, para mas información contactar al
              administrador.
            </Alert>
          )}
        {!!politicsAndProcedureError && (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            {politicsAndProcedureError}
          </Alert>
        )}
      </Container>
    </>
  );
};

export default PoliticsAndProcedures;
